if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = this.checkbox && document.getElementById(this.checkbox.getAttribute('form'));
      if (!this.form || this.submitHandler) return;
      this.submitHandler = this.handleSubmit.bind(this);
      this.changeHandler = this.clearError.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
      this.checkbox.addEventListener('change', this.changeHandler);
    }
    disconnectedCallback() {
      if (!this.form || !this.submitHandler) return;
      this.form.removeEventListener('submit', this.submitHandler);
      this.checkbox.removeEventListener('change', this.changeHandler);
      this.submitHandler = null;
    }
    clearError() {
      if (!this.checkbox.checked) return;
      this.querySelector('.cart_term_error')?.remove();
      this.checkbox.removeAttribute('aria-invalid');
      this.checkbox.removeAttribute('aria-describedby');
    }
    handleSubmit(event) {
      if (event.submitter && event.submitter.name !== 'checkout') return;
      if (this.checkbox.checked) {
        this.clearError();
        return;
      }
      event.preventDefault();
      let error = this.querySelector('.cart_term_error');
      if (!error) {
        error = document.createElement('p');
        error.id = `${this.checkbox.id}-error`;
        error.textContent = theme.strings.cartTermsConfirmation;
        error.classList.add('cart_term_error', 'flex-auto', 'text-center', 'mt-2', 'text-sm', 'text-red');
        error.setAttribute('role', 'alert');
        this.appendChild(error);
      }
      this.checkbox.setAttribute('aria-invalid', 'true');
      this.checkbox.setAttribute('aria-describedby', error.id);
      this.checkbox.focus();
    }
  }
  customElements.define('cart-terms', CartTerms);
}
